/** Textos y etiquetas compartidos entre la campana (Header) y los toasts en tiempo real. */

export const ESCUDO_URBANO_ALERT_TITLE = 'Alerta de Escudo Urbano';

/** Tipos EU por número de sonido / alarm_type_id (orden vigente en campo). */
export const EU_ALARM_TYPE_LABELS: Record<number, string> = {
  1: 'Alerta de Atraco',
  2: 'Alerta de vigilancia constante',
  3: 'Alerta de consumo',
  4: 'Alerta de Expendio',
  5: 'Alerta de riña',
  14: 'Alerta personalizada',
};

const EU_ALARM_SOUND_KEYS = new Set([1, 2, 3, 4, 5, 14]);

export function formatRelativeTime(iso?: string): string | null {
  if (!iso) return null;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return null;
  const diffMs = Date.now() - t;
  const m = Math.floor(diffMs / 60000);
  if (m < 1) return 'Ahora';
  if (m < 60) return `Hace ${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `Hace ${h} h`;
  return new Date(t).toLocaleString('es-CO', { dateStyle: 'short', timeStyle: 'short' });
}

export function resolveEuAlarmTypeLabel(input: {
  alarmTypeId?: number;
  sound?: number;
  message?: string;
  alertType?: string;
}): string {
  const fromId = input.alarmTypeId;
  if (fromId != null && Number.isFinite(fromId) && EU_ALARM_SOUND_KEYS.has(fromId)) {
    return EU_ALARM_TYPE_LABELS[fromId];
  }
  const sound = input.sound;
  if (sound != null && Number.isFinite(sound) && EU_ALARM_SOUND_KEYS.has(sound)) {
    return EU_ALARM_TYPE_LABELS[sound];
  }
  const msg = (input.message || '').trim();
  if (msg) return msg;
  const at = (input.alertType || '').trim();
  if (at) return at;
  return 'Alarma sin clasificar';
}
